import {ListModel} from '../../shared/models/list.model';
import {Utilities} from '../../shared/utilities/utilities.model';
import {Appointment2Model} from './appointment.model';


export class Appointments2 extends ListModel {

	constructor(model?: any) {
		super(model);
		this.items = [];
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
			model.items.forEach(appointment => this.items.push(new Appointment2Model(appointment)));
		}
	}
}
